import { getUser, renewToken } from "@functions/auth";
import { getSubdomainCodeEmail } from "@functions/getSubDomainSalud";
import { API_ERROR } from "@interfaces/catch-messages";
import axios, { AxiosRequestConfig } from "axios";
import i18next from "i18next";

export async function onRequestSuccess(config: AxiosRequestConfig)
{
    const user = await getUser();
    if(!user?.access_token) throw new Error(API_ERROR.COULD_NOT_GET_ACCESS_TOKEN);

    const lang = i18next.language;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const originCode = getSubdomainCodeEmail();
    
    config.headers.common = {
        Authorization: `Bearer ${user.access_token}`,
        timezone: timezone,
        lang: lang,
        appOrigin: originCode
    };
    return config;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function onResponseRejected(error: any)
{
    console.error("Interceptor rejected", error);
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) 
    {
        originalRequest._retry = true;
        console.error("Renew token...");
        const user = await renewToken();
        console.debug("Token renewed");
        if(user?.access_token)
        {
            originalRequest.headers.common = {
                Authorization: `Bearer ${user.access_token}`
            };
            return axios(originalRequest);
        }
    }
    return Promise.reject(error);
}
